import { render } from "./Autocomplete.vue?vue&type=template&id=ab4d0ec4"
import script from "./Autocomplete.vue?vue&type=script&lang=js"
export * from "./Autocomplete.vue?vue&type=script&lang=js"
script.render = render

export default script